// https://qr.daikin.eu?N=EKHBRD016ADY17&P=609940&M=1700649

const parseQueryString = function(queryString) {
  const params = {}

  // Split into key/value pairs
  const queries = queryString.split('&')
  let temp
  // Convert the array of strings into an object
  for (let i = 0; i < queries.length; i++) {
    temp = queries[i].split('=')
    params[temp[0]] = temp[1]
  }

  return params
}

export default (ctx, inject) => {
  inject('parseQrCode', (codeUrl) => {
    if (!codeUrl || codeUrl === '') {
      return null
    }
    const urlParts = codeUrl.split('?')
    if (urlParts.length >= 2) {
      const queryPart = urlParts[1]
      const params = parseQueryString(queryPart)
      return { serial: params.M, material: params.N }
    } else {
      return null
    }
  })
}
